import styled, { css } from 'styled-components'
import { mq } from '.'

// 1rem mobile -> 15px, 1rem desktop -> 18px
const rem = {
  baseMobile: 15,
  base: 18,
  get: (value, factor) => `${value / factor}rem`
}

export const getP50 = () => {
  return css`
    font-size: ${rem.get(50, rem.baseMobile)};
    font-weight: regular;
    line-height: ${rem.get(54, rem.baseMobile)};
    letter-spacing: -3.81px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(50, rem.base)};
      line-height: ${rem.get(54, rem.base)};
      letter-spacing: -3.81px;
    }
  `
}

export const getP40 = () => {
  return css`
    font-size: ${rem.get(40, rem.baseMobile)};
    font-weight: 300;
    line-height: ${rem.get(46.92, rem.baseMobile)};
    letter-spacing: -0.4px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(40, rem.base)};
      line-height: ${rem.get(46.92, rem.base)};
    }
  `
}

export const getP30 = () => {
  return css`
    font-size: ${rem.get(20, rem.baseMobile)};
    font-weight: 700;
    line-height: ${rem.get(24, rem.baseMobile)};
    letter-spacing: -0.2px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(30, rem.base)};
      line-height: ${rem.get(42, rem.base)};
      letter-spacing: -0.3px;
    }
  `
}


export const getP20 = () => {
  return css`
    font-size: ${rem.get(20, rem.baseMobile)};
    font-weight: 400;
    line-height: ${rem.get(26.2, rem.baseMobile)};
    letter-spacing: 0px;
    font-family: var(--font-domaine-display);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(26.2, rem.base)};
      letter-spacing: 0px;
    }
  `
}
export const getP20_1 = () => {
  return css`
    font-size: ${rem.get(20, rem.baseMobile)};
    font-weight: 400;
    line-height: ${rem.get(24, rem.baseMobile)};
    letter-spacing: 0px;
    font-family: var(--font-domaine-display);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(24, rem.base)};
      letter-spacing: 0px;
    }
  `
}


export const getP18_1 = () => {
  return css`
    font-size: ${rem.get(15, rem.baseMobile)};
    font-weight: 300;
    line-height: ${rem.get(19, rem.baseMobile)};
    letter-spacing: -0.3px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(22, rem.base)};
      letter-spacing: -0.36px;
    }
  `
}

export const getP18_1B = () => {
  return css`
    font-size: ${rem.get(15, rem.baseMobile)};
    font-weight: 500;
    line-height: ${rem.get(19, rem.baseMobile)};
    letter-spacing: -0.3px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      font-weight: 700;
      line-height: ${rem.get(22, rem.base)};
      letter-spacing: 0px;
    }
  `
}

export const getP16 = () => {
  return css`
    font-size: ${rem.get(16, rem.baseMobile)};
    font-weight: 400;
    line-height: ${rem.get(19, rem.baseMobile)};
    letter-spacing: 0px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0;
    }
  `
}
export const getP16_1b = () => {
  return css`
    font-size: ${rem.get(16, rem.baseMobile)};
    font-weight: 600;
    line-height: ${rem.get(19, rem.baseMobile)};
    letter-spacing: 0px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0;
    }
  `
}


export const getP15 = () => {
  return css`
    font-size: ${rem.get(12, rem.baseMobile)};
    font-weight: 700;
    line-height: ${rem.get(15, rem.baseMobile)};
    letter-spacing: 0.13px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0.17px;
    }
  `
}

export const getP15_1 = () => {
  return css`
    font-size: ${rem.get(12, rem.baseMobile)};
    font-weight: light;
    line-height: ${rem.get(15, rem.baseMobile)};
    letter-spacing: -0.4px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(20, rem.base)};
      letter-spacing: -0.5px;
    }
  `
}

export const getP15_1B = () => {
  return css`
    font-size: ${rem.get(15, rem.baseMobile)};
    font-weight: 300;
    line-height: ${rem.get(15, rem.baseMobile)};
    letter-spacing: -0.4px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(20, rem.base)};
      letter-spacing: -0.5px;
    }
  `
}



export const getP15_2 = () => {
  return css`
    font-size: ${rem.get(15, rem.baseMobile)};
    font-weight: 300;
    line-height: ${rem.get(14, rem.baseMobile)};
    letter-spacing: -.38px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(14, rem.base)};
    }
  `
}


export const getP12 = () => { // new
  return css`
    font-size: ${rem.get(9, rem.baseMobile)};
    font-weight: 700;
    line-height: ${rem.get(15, rem.baseMobile)};
    letter-spacing: 0.1px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0.13px;
    }
  `
}


export const getP12_1 = () => {
  return css`
    font-size: ${rem.get(10, rem.baseMobile)};
    font-weight: 300;
    line-height: ${rem.get(13, rem.baseMobile)};
    letter-spacing: -0.33px;
    font-family: var(--font-work-sans);

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(14, rem.base)};
      letter-spacing: -0.3px;
    }
  `
}

export const getP20v2 = css`
  font-size: ${rem.get(20, rem.base)};
  line-height: ${rem.get(24, rem.base)};
  letter-spacing: .5px;

  ${mq.greaterThan('tablet')} {
    font-size: ${rem.get(20, rem.base)};
    line-height: ${rem.get(24, rem.base)};
    letter-spacing: .5px;
  }
`

export const H1 = styled.h1`
  ${getP50()}
`
export const H2 = styled.h2`
  ${getP30()}
`
export const H3 = styled.h3`
  ${getP20()}
`
export const H4 = styled.h4`
  ${getP18_1()}
`
export const H5 = styled.h5`
  ${getP15()}
`
export const H6 = styled.h6`
  ${getP12_1()}
`

